/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
// const axios = require('../../../../../node_modules/axios/dist/node/axios.cjs');
//import axios from 'axios';
import FileBase64 from 'react-file-base64';
import localStorage from '../../../../utils/localStorage';
import { SelectComponent } from '../Widgets';
import { Form, Input, InputNumber, Row, message, Col, Tree, DatePicker } from 'antd';
import { TableInsideTables } from '../Widgets';
import { DownOutlined, UpCircleFilled } from '@ant-design/icons';
import { API_DEVICE, LOGBOOK, API_HIERARCHYMODULE } from '../../../../commons/api';
const { TreeNode } = Tree;

const FormTableWithMultiSubHedearTable = (props) => {

const [formObject,setFormObject] = useState(cloneDeep(props.formObject) || {});
const [,setColumns] = useState(props.formObject && props.formObject.columns ? props.formObject.columns : []);
const [,setData] = useState(props.formObject && props.formObject.datasource ? props.formObject.datasource : []);
//const [activeKey,setActiveKey] = useState([]);
const [,setHeaderValue] = useState({});
//const [recordType,setRecordType] = useState(props.recordType || '');
//const [remarks,setRemarks] = useState('');
//const [shift,setShift] = useState('daily');
const [deviceList,setDeviceList] = useState([]);
const [autoExpandParent,setAutoExpandParent] = useState(true);
const [header,setHeader] = useState(null);
const [,setUserProfile] = useState(null);
const [,setElog] = useState(props.elog);
const [hierarchy,setHierarchy] = useState(null);
const [,setSelectedKeys] = useState(null);
const [,setExpandedKeys] = useState(null);
const [translationCache] = useState(props.translationCache || {});

useEffect(() => {
  let formObjectNew = cloneDeep(props.formObject);
  getDeviceList();
  getMenuHierarchyStructure();
  setColumns(props.formObject && props.formObject.columns ? props.formObject.columns : []);
  setData(props.formObject && props.formObject.datasource ? props.formObject.datasource : []);
  formObjectNew = {
    ...formObject
  };
  props.downTimeData(formObjectNew);
},[]);

useEffect(() => {

  setFormObject(cloneDeep(props.formObject));
  setColumns(props.formObject && props.formObject.columns ? props.formObject.columns: []);
  setData(props.formObject && props.formObject.datasource ? props.formObject.datasource:[]);
  setHeaderValue(props.headerValue);
  setHeader(header);
  setUserProfile(props.setUserProfile);
  setElog(props.elog);
  

},[props.formObject,props.headerValue,props.header,props.elog,props.userProfile]);

 const getMenuHierarchyStructure = async () => {
    const userData = localStorage.get('modules') && JSON.parse(localStorage.get('modules'));
    if (userData && userData.hierarchy) {
      let hierarchyCode = userData.hierarchy[0].HierarchyCode;
      let hierarchyObj = await getHierarchyLevel(hierarchyCode);
      let final = hierarchyObj.map((obj) => {
        return renameProperty(obj, 'Name', 'title');
      });
      setHierarchy(final);
      
    }
  };
  // getHierarchyLevel = (Code) => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   let obj = {
  //     method: 'GET',
  //     url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?HierarchyCode=${Code}&SiteId=${siteId}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   return axios(obj)
  //     .then((response) => {
  //       return response.data;
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };
const getHierarchyLevel = async(Code) => {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');

  return await fetch(`${API_HIERARCHYMODULE.GetHierarchyLevels}?HierarchyCode=${Code}&SiteId=${siteId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the JSON from the response
  })
  .catch((error) => {
    console.log(error);
  });
};

  // getDeviceList = () => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   const headers = {
  //     method: 'GET',
  //     url: `${API_DEVICE.GET}?SiteId=${siteId}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   axios(headers)
  //     .then((res) => {
  //       let deviceList = res.data;
  //       this.setState({ deviceList });
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const getDeviceList = () => {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');

  fetch(`${API_DEVICE.GET}?SiteId=${siteId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); 
  })
  .then((data) => {
    setDeviceList(data);
  })
  .catch((error) => {
    console.log(error);
  });
};


const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
    if (obj && obj.children) {
      let children = obj.children.map((objChildren) => {
        return renameProperty(objChildren, oldName1, newName1, oldName2, newName2);
      });
      obj['children'] = children;
      obj[newName1] = obj[oldName1];
      delete obj[oldName1];
      // obj[newName2] = obj[oldName2];
      // delete obj[oldName2];
      return obj;
    } else {
      obj[newName1] = obj[oldName1];
      delete obj[oldName1];
      // obj[newName2] = obj[oldName2];
      // delete obj[oldName2];
      return obj;
    }
  };

const onInputHeaderMainChange = (columnValue, columnKey) => {
   let formObjectNew = {};

    formObjectNew = {
      ...formObject,
      form: {
        ...formObject['form'],
        datasource: {
          ...(formObject && formObject['form'] && formObject['form'].datasource
            ? formObject['form'].datasource
            : {}),
          [columnKey]:
            columnValue && Array.isArray(columnValue) && columnValue.length === 2
              ? columnValue[1]
              : columnValue,
          ...(columnValue && Array.isArray(columnValue) && columnValue.length === 2
            ? {
                [`${columnKey}` + 1]: JSON.stringify(columnValue)
              }
            : {})
        }
      }
    };
    props.downTimeData(formObjectNew);
  };
 


 const onInputHeaderMainChangeBase64 = (columnValue, columnKey) => {
    let formObjectNew = {};
    formObjectNew = {
      ...formObject,
      form: {
        ...formObject['form'],
        datasource: {
          ...(formObject && formObject['form'] && formObject['form'].datasource
            ? formObject['form'].datasource
            : {}),
          [columnKey]:
            columnValue && Array.isArray(columnValue) && columnValue.length === 2
              ? columnValue[1]
              : columnValue.base64,
          ...(columnValue && Array.isArray(columnValue) && columnValue.length === 2
            ? {
                [`${columnKey}` + 1]: JSON.stringify(columnValue)
              }
            : {})
        }
      }
    };
    props.downTimeData(formObjectNew);
  };
  const onInputHeaderConditionMainChange = (columnValue, columnKey, entryCondition) => {
    let formObjectNew = {};
    let datasource =
      formObject && formObject['form'] && formObject['form'].datasource
        ? formObject['form'].datasource
        : [];
    if (entryCondition && entryCondition.clearFields && Array.isArray(entryCondition.clearFields)) {
      entryCondition.clearFields.map((fieldName) => {
        delete datasource[fieldName];
      });
    }
    datasource = {
      ...datasource,
      [columnKey]: columnValue
    };
    formObjectNew = {
      ...formObject,
      form: {
        ...formObject['form'],
        datasource
      }
    };
    props.downTimeData(formObjectNew);
  };

  const inputHeaderMainNumberChange = (minValue, maxValue, value, key, columns) => {
    if (
      value >= minValue &&
      value <= maxValue &&
      minValue !== undefined &&
      maxValue !== undefined
    ) {
       onInputHeaderMainChange(value, key);
    } else if (columns && columns.entryCondition) {
       onInputHeaderConditionMainChange(value, key, columns.entryCondition);
    } else if (minValue === undefined && maxValue === undefined) {
       onInputHeaderMainChange(value, key);
    } else {
       onInputHeaderMainChange('', key);
      message.error(`The input range must between ${minValue} and ${maxValue}`);
    }
  };

  const renderMainSwitch = (formObject, columns) => {
    switch (columns.widget) {
      case 'input':
        return (
          <Input
            style={{ width: '90%', fontWeight: 'bold' }}
            value={
              formObject['form'] &&
              formObject['form'].datasource &&
              formObject['form'].datasource[columns.key]
                ? formObject['form'].datasource[columns.key]
                : ''
            }
            maxLength={columns && columns.maxLength ? columns.maxLength : 100}
            disabled={columns.disable ? columns.disable : false}
            placeholder={columns.placeHolder}
            onChange={(e) => onInputHeaderMainChange(e.target.value, columns.key)}
          />
        );
      case 'inputNumber':
        return (
          <InputNumber
            style={{ width: '90%', fontWeight: 'bold' }}
            value={
              formObject['form'] &&
              formObject['form'].datasource &&
              formObject['form'].datasource[columns.key]
                ? formObject['form'].datasource[columns.key]
                : ''
            }
            min={columns.min ? columns.min : 0}
            max={columns.max ? columns.max : 1000000000}
            placeholder={columns.placeHolder}
            onChange={(e) =>
              inputHeaderMainNumberChange(columns.min, columns.max, e, columns.key, columns)
            }
            // onChange={(e) => this.onInputHeaderMainChange(e, columns.key)}
          />
        );
      case 'date-picker':
        return (
          <DatePicker
            value={
              formObject['form'] &&
              formObject['form']['datasource'] &&
              formObject['form']['datasource']['Date']
                ? moment(formObject['form']['datasource']['Date'], 'YYYY-MM-DD HH:mm:ss')
                : undefined
            }
            showNow={false}
            disabled={columns.disable ? columns.disable : false}
            //disabledDate={disabledDate}
            //onChange={(e) => onDateHeaderMainChange(e, columns.key)}
            style={{ width: '90%', fontWeight: 'bold' }}
          />
        );
      case 'select':
        return (
          <SelectComponent
            column={columns}
            record={{ key: columns }}
            text={
              columns && columns.hierarchy && columns.hierarchy === true
                ? formObject['form'] &&
                  formObject['form'].datasource &&
                  formObject['form'].datasource[`${columns.key}` + 1]
                  ? formObject['form'].datasource[`${columns.key}` + 1]
                  : ''
                : formObject['form'] &&
                  formObject['form'].datasource &&
                  formObject['form'].datasource[columns.key]
                ? formObject['form'].datasource[columns.key]
                : ''
            }
            userProfile={props.userProfile}
            disabled={columns.disable ? columns.disable : false}
            handleFieldChange={(e) => onInputHeaderMainChange(e, columns.key)}
            //handleKeyPress={this.handleKeyPress}
          />
        );
      case 'imageUploadBase64':
        return (
          <span>
            <FileBase64
              type="file"
              multiple={false}
              onDone={(file) => {
                onInputHeaderMainChangeBase64(file, columns.key);
              }}
            />
            {formObject['form'] &&
            formObject['form'].datasource &&
            formObject['form'].datasource[columns.key] ? (
              <div>
                <a
                  style={{ color: '#062d57' }}
                  href={formObject['form'].datasource[columns.key]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt=""
                    width="100"
                    height="100"
                    src={`${formObject['form'].datasource[columns.key]}`}
                  ></img>
                </a>
              </div>
            ) : null}
          </span>
        );
      case 'textArea':
        return (
          <div>
            <Input.TextArea
              rows={4}
              style={{ width: '90%', fontWeight: 'bold' }}
              value={
                formObject['form'] &&
                formObject['form'].datasource &&
                formObject['form'].datasource[columns.key]
                  ? formObject['form'].datasource[columns.key]
                  : ''
              }
              placeholder={columns.placeHolder}
              onChange={(e) => onInputHeaderMainChange(e.target.value, columns.key)}
              autoSize={{ minRows: 2, maxRows: 4 }}
              // style={{ width: '100%' }}
              maxLength={250}
            />
          </div>
        );
      default:
        return (
          <div>
            {formObject['form'] &&
            formObject['form'].datasource &&
            formObject['form'].datasource[columns.key] ? (
              formObject['form'].datasource[columns.key]
            ) : (
              <div>{'   '}</div>
            )}
          </div>
        );
    }
  };

  // checkDeviceExistsOrNot = (data) => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   const Object = {
  //     method: 'POST',
  //     url: `${LOGBOOK.GetDeviceData}?SiteId=${siteId}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     },
  //     data
  //   };
  //   return axios(Object)
  //     .then((response) => {
  //       return response.data;
  //     })
  //     .catch(() => {
  //       return {};
  //     });
  // };
  const checkDeviceExistsOrNot = (data) => {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');

  return fetch(`${LOGBOOK.GetDeviceData}?SiteId=${siteId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json' 
    },
    body: JSON.stringify(data) 
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); 
  })
  .catch(() => {
    return {}; 
  });
};

 const onExpand = (expandedKeys) => {
    setAutoExpandParent(false);
    setExpandedKeys(expandedKeys);
  };

  const onSelect = async (selectedKeys) => {
   let formObjectNew = {};
    let deviceObject =
      deviceList &&
      Array.isArray(deviceList) &&
      deviceList.filter((device) => {
        return device.DeviceCode === selectedKeys[0];
      });
    if (deviceObject && deviceObject.length > 0) {
      let payload = {
        DeviceAlias: deviceObject && deviceObject[0] ? deviceObject[0].AliasCode : '',
        eLogReferenceId:
          props && props.elog && props.elog.eLogReferenceId
            ? props.elog.eLogReferenceId
            : ''
      };
      let checkDeviceExits = await checkDeviceExistsOrNot(payload);
      let checkStatus = false;
      hierarchy.map(() => {
        if (checkDeviceExits && Array.isArray(checkDeviceExits) && checkDeviceExits.length > 0) {
          if (checkStatus === false) {
            props.checkDeviceExistsOrNot(checkDeviceExits);
          }
          checkStatus = true;
        } else {
          formObjectNew = {
            ...formObject,
            form: {
              ...formObject['form'],
              datasource: {
                DeviceId: selectedKeys[0]
              }
            },
            table: {
              ...formObject['table'],
              datasource: []
            }
          };
          setSelectedKeys(selectedKeys[0]);
          props.downTimeData(formObjectNew);
        }
      });
    } else {
      message.error('Please select device');
    }
  };

  const getData = (selectedKey) => {
    onSelect([selectedKey]);
  };

  const setTranslation = (keyword) => {
    return translationCache && translationCache[keyword] && translationCache[keyword]
      ? translationCache[keyword]
      : keyword;
  };

 const saveTableViewData = (list) => {
    let formObjectNew = {};
    formObjectNew = {
      ...formObject,
      table: {
        ...(formObject && formObject['table'] ? formObject['table'] : {}),
        ...list
      }
    };
 
     props.downTimeData(formObjectNew);
  };
  
  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode
              title={`${setTranslation(item.title)}${
                item.ShortDescription ? `-${setTranslation(item.ShortDescription)}` : ''
              }`}
              key={item.key}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={item.key}
            title={
              <div onClick={() => getData(item.key)}>
                {' '}
                <UpCircleFilled style={{ marginRight: '10px' }} />
                {`${setTranslation(item.title)}${
                  item.ShortDescription ? `-${setTranslation(item.ShortDescription)}` : ''
                }`}
              </div>
            }
            dataRef={item}
            showIcon={true}
          />
        );
      })
    );
  };

  
    return (
      <div style={{ marginTop: '30px', marginBottom: '30px', color: 'white', fontWeight: 'bold' }}>
        <Form
          //className="batchUpdateForm1"
          name="basic"
          labelCol={{
            span: 6
          }}
          wrapperCol={{
            span: 16
          }}
        >
          <Row
            style={{
              padding: '10px',
              border: '3px solid gray'
            }}
          >
            <Col span={8}>
              <div
                style={{
                  padding: '10px'
                }}
              >
                <label style={{ fontWeight: 'bold', color: 'white' }}>
                  {' '}
                  {translationCache && translationCache['Sensor']
                    ? translationCache['Sensor']
                    : 'Sensor'}{' '}
                  :
                </label>
                <Tree
                  showIcon
                  defaultExpandAll={true}
                  // expandedKeys={this.state.expandedKeys}
                  switcherIcon={<DownOutlined />}
                  onExpand={onExpand}
                  autoExpandParent={autoExpandParent}
                  selectedKeys={[
                    formObject &&
                    formObject.form &&
                    formObject.form.datasource &&
                    formObject.form.datasource.DeviceId
                      ? formObject.form.datasource.DeviceId
                      : ''
                  ]}
                >
                  {renderTreeNodes(hierarchy)}
                </Tree>
              </div>
            </Col>
            <Col span={16}>
              <div
                style={{
                  padding: '10px',
                  borderLeft: '3px dashed gray'
                }}
              >
                <Row>
                  {formObject && formObject['form'] && formObject['form'].columns
                    ? formObject['form'].columns.map((columns, index) => {
                        if (columns && columns.widget === 'heading') {
                          return (
                            <div
                              key={index}
                              style={{
                                fontWeight: 'bold',
                                fontSize: '18px',
                                margin: '15px 0px 10px 0px',
                                color: 'black',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                //backgroundColor: 'steelblue',
                                width: '100%'
                              }}
                            >
                              {columns && columns.displayName
                                ? translationCache &&
                                  translationCache[columns.displayName] &&
                                  translationCache[columns.displayName]
                                  ? translationCache[columns.displayName]
                                  : columns.displayName
                                : ''}
                            </div>
                          );
                        } else {
                          return (
                            <div style={{ width: '90%', display: 'flex' }} key={index}>
                              <Form.Item
                                style={{ width: '90%', color: 'white' }}
                                required={false}
                                label={
                                  <span style={{ marginLeft: columns.marginLeft, color: 'white' }}>
                                    {translationCache &&
                                    translationCache[columns.displayName] &&
                                    translationCache[columns.displayName]
                                      ? translationCache[columns.displayName]
                                      : columns.displayName}
                                  </span>
                                }
                              >
                                <div>
                                  {renderMainSwitch(formObject, columns)}
                                  <span style={{ marginLeft: '5px' }}>
                                    {columns && columns.units ? columns.units : ''}
                                  </span>
                                </div>
                              </Form.Item>
                            </div>
                          );
                        }
                      })
                    : null}
                </Row>
              </div>

              <div
                style={{
                  padding: '10px'
                }}
              >
                <TableInsideTables
                  form={formObject && formObject['table'] ? formObject['table'] : {}}
                  formObject={formObject}
                  recordType={'FormSubSectionTable'}
                  saveTableViewData={(e) => saveTableViewData(e)}
                  showAddButton={
                    formObject && formObject['table'] && formObject['table'].showAddButton
                      ? formObject['table'].showAddButton
                      : false
                  }
                  translationCache={props.translationCache}
                  status={props.status}
                  deviceId={
                    formObject &&
                    formObject.form &&
                    formObject.form.datasource &&
                    formObject.form.datasource.DeviceId
                      ? formObject.form.datasource.DeviceId
                      : ''
                  }
                />
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    );
  };


export default FormTableWithMultiSubHedearTable;
